import type { DelayUnit } from '../types/email.types';

/**
 * Delay unit multipliers for converting to seconds
 */
export const DELAY_MULTIPLIERS: Record<DelayUnit, number> = {
    minutes: 60,
    hours: 3600,
    days: 86400,
} as const;

/**
 * Default delay values
 */
export const DEFAULT_DELAY = {
    SECONDS: 0,
    VALUE: 0,
    UNIT: 'minutes' as DelayUnit,
} as const;

/**
 * Delay text for immediate sending
 */
export const IMMEDIATE_DELAY_TEXT = 'Right away';
